import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { PENDING_DEEP_LINK_PATH_KEY } from '../../services/deep-link.service';

export const authGuardGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const token = localStorage.getItem('token');
  if (token) return true;
  if (state?.url && state.url !== '/' && !state.url.startsWith('/signin')) {
    localStorage.setItem(PENDING_DEEP_LINK_PATH_KEY, state.url);
  }
  router.navigate(['/signin']);
  return false;
};
